import axios from "axios";
import { authFetch } from "../helpers/FetchHelpers";

const { default: DataService } = require("./DataService");

class ProductDataService extends DataService {
    constructor() {
        super("product")
    }

    getList(keyword, warehouseId, currentPage, perPage, isActive, isEmoney=false) {
        const params = new URLSearchParams();

        if (typeof keyword !== 'undefined') {
            params.append('keyword', keyword);
        }

        if (isEmoney === true) {
            params.append('type', 'eproduct');
        }

        if (typeof isActive !== 'undefined') {
            params.append('status', isActive);
        }

        if (warehouseId !== -1 && typeof warehouseId !== 'undefined') {
            params.append('warehouse_id', warehouseId);
        }

        if (typeof currentPage !== 'undefined') {
            params.append('page', currentPage);
        }

        if (typeof perPage !== 'undefined') {
            params.append('per_page', perPage);
        }

        const url = `${process.env.REACT_APP_API_URL}/${this.entity}/list?${params.toString()}`;

        return authFetch(url, 'GET', null)
            .then((data) => {
                return {
                    products: data.data.products !== null && data.data.errorMessage === undefined ? data.data.products : [],
                    totalPages: data.data.total_product < perPage ? 1 : Math.ceil(data.data.total_product / perPage),
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    add(item) {
        const bodyArray = []
        bodyArray.push(item)

        return super.add(bodyArray);
    }

    getByBarcode(barcode, page, perPage) {
        const clauses = "product_barcode=" + barcode + '&per_page=' + perPage + '&page=' + page;
        return super.get(clauses)
            .then((data) => {
                return {
                    products: data.data != null && data.data.errorMessage === undefined ? [data.data] : [],
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    getById(id) {
        const clauses = "product_id=" + id;
        return super.get(clauses)
            .then((data) => {
                return {
                    product: data.data != null && data.data.errorMessage === undefined ? data.data : undefined,
                    errorMessage: data.data?.errorMessage,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    update(item) {
        const body = Object.assign({}, item)
        if (body.product_barcode === body.current_barcode) {
            delete body.product_barcode
        }
        delete body.current_barcode

        return super.update(body);
    }

    disable(item) {
        const body = {
            product_id: item.product_id,
            product_name: item.product_name,
            status: item.status
        };

        return super.update(body);
    }

    export() {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            timeout: 60000,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwt_auth_token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        let url = '/inventory/download';
        let body = {
            total_fetch_product: 1000000,
        };

        return instance.post(url, body, {
            responseType: 'arraybuffer',
        }).then(response => {
            // response.data is an empty object
            const blob = new Blob([response.data], {
                type: 'application/xlsx',
            });
            var FileSaver = require('file-saver');
            FileSaver.saveAs(blob, 'products.xlsx');
        })
    }

    splitStock(product_id, stock_request) {
        return authFetch(process.env.REACT_APP_API_URL + '/stock', 'POST', JSON.stringify({
            usecase: 'split',
            product_id,
            stock_request,
        }))
    }

    updateStock(product_id, stock_request) {
        return authFetch(process.env.REACT_APP_API_URL + '/stock', 'POST', JSON.stringify({
            product_id,
            stock_request,
        }))
    }
}

export default ProductDataService;
